import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  RouterStateSnapshot,
} from '@angular/router';

@Injectable()
export class AuthenticatedLoginGuard implements CanActivate {
  isAuthenticated = false;

  constructor(
  ) // public eddress: EddressFacadeService
  {}

  public canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean {
    // this.authService.isAuthenticated.subscribe(
    // 	(data) => (this.isAuthenticated = data)
    // );
    // if (this.isAuthenticated) {
    // 	this.permissionsService.permissions$.subscribe((per) => {
    // 		const redirectUrl = this.eddress.utilityService.getRedirectUrl(per);
    // 		if (redirectUrl) {
    // 			this.router.navigateByUrl(redirectUrl);
    // 		}
    // 	});
    // }
    return true;
  }
}
